import React from 'react';
import './style.scss';

interface WellStatusProps {
  value: string;
}

const WellStatus: React.FC<WellStatusProps> = ({ value }) => {
  const getWellStatusClass = (runStatus?: string): string => {
    if (!runStatus) return 'well-status-cell__default';
    const lower = runStatus.toLowerCase();
    if (lower.includes('running')) return 'well-status-cell__running';
    if (lower.includes('shutdown')) return 'well-status-cell__shutdown';
    if (lower.includes('idle')) return 'well-status-cell__idle';
    if (lower.includes('failure')) return 'well-status-cell__failure';
    if (lower.includes('disabled')) return 'well-status-cell__disabled';
    return 'well-status-cell__default';
  };
  if (value?.length === 0) {
    return <div>-</div>;
  }
  return (
    <div className={`well-status-cell ${getWellStatusClass(value)}`}>
      <div className='well-status-cell__text'>{value}</div>
    </div>
  );
};
export default WellStatus;
